import FreeTrialButton from "./FreeTrialButton";

export default function SharedCTASection() {
  return (
    <section
      className="relative z-10 w-full flex flex-col items-center text-center px-6 md:px-24 lg:px-48 py-16 md:py-[104px]"
      style={{ backgroundColor: "#15121D" }}
    >
      <h2
        className="lowercase mb-5"
        style={{ fontFamily: "Inter, sans-serif", fontWeight: 800, fontSize: "clamp(32px, 8vw, 64px)", lineHeight: "1.1", letterSpacing: "-2.56px", color: "#E7DFF0" }}
      >
        serve more. sell smarter. grow faster.
      </h2>
      <p
        className="lowercase mb-10"
        style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "clamp(16px, 4vw, 24px)", lineHeight: "1.5", letterSpacing: "0px", color: "#FFFFFF", maxWidth: "680px" }}
      >
        join the elite businesses already scaling with beɘmz. set up in minutes, grow for a lifetime.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4">
        <FreeTrialButton onClick={() => window.location.href = "/business/get-started"} label="get started free" />
        <button
          onClick={() => window.location.href = "/business/contact"}
          className="inline-flex items-center justify-center w-[165px] h-[50px] rounded-full text-white text-sm font-medium lowercase cursor-pointer transition-opacity hover:opacity-80 whitespace-nowrap"
          style={{ border: "1px solid rgba(255,255,255,0.35)" }}
        >
          talk to sales
        </button>
      </div>
    </section>
  );
}
